import * as yup from 'yup'

export const schama = yup.object().shape({
  idCardNo: yup
    .string()
    .required('กรุณากรอกเลขประจำตัวประชาชน 13 หลัก')
    .min(13, 'กรุณากรอกเลขประจำตัวประชาชน 13 หลัก'),
})
